import Modal from 'developer_components/newModal';
import EventEmitter from 'methods/eventEmitter';
import {generateHash} from 'methods/utils';
import {bindGoogleRegistrationBlockedPopupHandler} from 'components/authorization-modal/google-auth-blocked';

/**
 * Модалка авторизации
 */
function AuthorizationModal() {
    // наследуемся
    EventEmitter.call(this);

    this.modal_id  = 'authorization';
    this._$element = Modal.createFromHTML(
        `<div class="Authorization-modal container">
            <div class="background"></div>
            <div class="form">
                <div class="form-header">
                    <div class="mobile-wrapper">
                        <div class="logo"></div>
                        <button class="close-button js-modalClose"></button>
                    </div>
                    <div class="cross-wrapper"><div class="cross js-modalClose"></div></div>
                </div>
                <div class="form-content">
                    <div class="header-title">Авторизация</div>
                    <form action="/users_v2/authorization/" method="post" class="fields">
                        <div class="field" data-type="email">
                            <span class="title">Введите адрес электронной почты</span>
                            <input type="text" class="input" name="email" required placeholder="E-mail" autocomplete="email">
                            <span class="hint"></span>
                        </div>

                        <div class="field password-field" data-type="password">
                            <span class="title">Введите пароль</span>

                            <div class="password-input-wrapper">
                                <input type="password" name="password" class="input" required placeholder="Пароль">
                                <div class="eye js-passwordVisibility"></div>
                            </div>

                            <div class="hint-wrapper">
                                <span class="hint no-padding"></span>
                                <a href="javascript:void(0);" data-modal_id="forgot" class="forgot">Не помню пароль</a>
                            </div>
                        </div>

                        <button class="button">Войти</button>
                    </form>
                    <div class="socials">
                        <span class="js-social social vk" data-url="https://oauth.vk.com/authorize?client_id=6252553&redirect_uri=${location.origin}/users_v2/auth/vk/&scope=4194305&display=mobile"></span>
                        <span class="js-social social yandex" data-url="https://oauth.yandex.ru/authorize?response_type=code&client_id=2d0ee8b146a94a71958f6e69ae0ac1fd&redirect_uri=${location.origin}/users_v2/auth/yandex/&force_confirm=yes"></span>
                        <span class="js-social social google" data-url="https://accounts.google.com/o/oauth2/auth?redirect_uri=${location.origin}/users_v2/auth/google/&response_type=code&client_id=1086070594189-e4vlpa9g2ukhm280l2j8h9s86tfdhtce.apps.googleusercontent.com&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile"></span>
                        <span class="js-social social mail" data-url="https://oauth.mail.ru/login?client_id=50c3a57533f74a4abe3f465211c0f4eb&response_type=code&redirect_uri=${location.origin}/users_v2/auth/mail/&state=${generateHash(256)}&prompt_force=1"></span>
                    </div>
                    <div class="caption">
                        <p>Авторизуясь, вы соглашаетесь с правилами использования сервиса и обработки <a href="/about/polzovatelskoe_soglashenie/" target="_blank">персональных данных</a>.</p>
                        <p><a href="https://privettur.ru/about/obrabotka_personalnyh_dannyh/" target="_blank">Политика в отношении обработки персональных данных</a></p>
                        <p><a href="https://privettur.ru/about/soglasie_na_obrabotku_personalnyh_dannyh/" target="_blank">Согласие на обработку персональных данных</a></p>
                    </div>
                </div>
                <div class="form-footer">
                    У вас еще нет аккаунта? <span class="link" data-modal_id="registration">Зарегистрироваться</span>
                </div>
            </div>
        </div>`,
        {
            id: this.modal_id,
        }
    );

    // наследование
    Modal.call(this, this._$element, {
        modal_id: this.modal_id,
    });

    this._events = {
        togglePasswordVisibility: (e) => {
            let $eye   = e.target;
            let $input = e.target.parentNode.querySelector('input');
            let type   = $input.getAttribute('type') === 'password' ? 'text' : 'password';

            $eye.classList.toggle('active', !$eye.classList.contains('active'));
            $input.setAttribute('type', type);
        },
        submit: (e) => {
            e.preventDefault();
            e.stopPropagation();

            // защита от повторной отправки
            if (this._$form.classList.contains('is-loading')) {
                return false;
            }
            this._$form.classList.add('is-loading');

            // убираем ошибки
            this._$element.querySelectorAll('.field').forEach($field => {
                $field.classList.remove('error');

                let $hint = $field.querySelector('.hint');
                if ($hint) {
                    $hint.textContent = '';
                }
            });

            fetch(this._$form.getAttribute('action'), {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new FormData(this._$form),
            })
            .then(response => response.json())
            .then(r => {
                if (r.status === 'ok' && r.redirect) {
                    location.href = r.redirect;
                } else if (r.fields) {
                    this._$element.querySelectorAll('.field').forEach($field => {
                        let name = $field.dataset.type;

                        if (name && r.fields[name]) {
                            $field.classList.add('error');

                            let $hint = $field.querySelector('.hint');
                            if ($hint) {
                                $hint.textContent = r.fields[name];
                            }
                        }
                    });
                } else if (r.message) {
                    alert(r.message);
                }

                this._$form.classList.remove('is-loading');
            });
        }
    }

    this.init = function() {
        this._$passwordVisibility = this._$element.querySelector('.js-passwordVisibility');
        this._$form               = this._$element.querySelector('form');

        // показать пароль
        this._$passwordVisibility.addEventListener('click', this._events.togglePasswordVisibility);

        // форма
        this._$form.addEventListener('submit', this._events.submit);

        /**
         * Всплывающее окно авторизации vk, fb, ok
         */
        this._winParams = {
            vk: "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=820,height=435",
        }

        bindGoogleRegistrationBlockedPopupHandler();

        this._$element.querySelectorAll('.js-social').forEach($button => $button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const requestURL = location.origin + location.pathname;
            const winParam = $button.classList.contains('vk') ? this._winParams.vk
                           : '';

            // создаем окно
            window.popup = window.open($button.dataset.url, "_blank", winParam);

            // создаем callback function
            window.popup_ok = function(user_type_id = 1) {
                window.popup.close();

                // отельер
                if (user_type_id == 2) {
                    location.href = '/lk/booking/';
                } else {
                    location.href = 'https://panel.privettur.ru/'
                }
            }

            // создаем callback function
            window.popup_cancel = function() {
                window.popup.close();
            }
        }));
    }
    this.init();
}

AuthorizationModal.prototype = Object.create(Modal.prototype, {
    constructor: {
        value: AuthorizationModal,
        enumerable: false,
        writable: true,
    }
});

export default AuthorizationModal;
